import React from "react";
import { Link } from "react-router-dom";
import FooterCta from "./FooterCta";
import FooterOneCopyrights from "./FooterOneCopyrights";
import footerMap from "../../assets/img/footer-map.png";
import GoogleMap from "../Contact/GoogleMap";
const FooterTwo = () => {
  return (
    <footer className="footer-2 footer-wrap">
      <div className="footer-widgets-wrapper text-white">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 pe-xl-0 col-sm-6 col-12">
              <div className="single-footer-wid site_info_widget">
                <div className="wid-title">
                  <h3>Get In Touch</h3>
                </div>
                <div className="contact-us">
                  <div className="single-contact-info">
                    <div className="icon">
                      <i className="fal fa-phone"></i>
                    </div>
                    <div className="contact-info">
                      <a
                        href="telto:917600048000"
                        style={{
                          fontWeight: "normal",
                        }}
                      >
                        +91-7600048000
                      </a>
                      <br/>
                      {/* <a
                        href="telto:912822250246"
                        style={{
                          fontWeight: "normal",
                        }}
                      >
                        +91-2822–250246
                      </a> */}
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="icon">
                      <i className="fal fa-envelope"></i>
                    </div>
                    <div className="contact-info">
                    
                        <a
                          href="mailto:info@shreegita.com"
                          style={{
                            fontWeight: "normal",
                          }}
                        >
                          info@shreegita.com
                        </a>
                       
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="icon">
                      <i className="fal fa-map-marker-alt"></i>
                    </div>
                    <div className="contact-info">
                      <p>Panchasar Road, Morbi–363641, (Guj.) INDIA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 offset-xl-1 col-xl-3 ps-xl-5 col-12">
              <div className="single-footer-wid">
                <div className="wid-title">
                  <h3>Quick Links</h3>
                </div>
                <ul>
                  <li>
                    <Link to="/about">About </Link>
                  </li>
                  <li>
                    <Link to="/companyprofile">Company Profile </Link>
                  </li>
                  <li>
                    <Link to="/products">Our Products </Link>
                  </li>
                  <li>
                    <Link to="/Inquiry">Inquiry </Link>
                  </li>
                  <li>
                    <Link to="/Gallery">Gallery </Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* <div className="col-sm-6 col-xl-4 offset-xl-1 col-12">
              <div className="single-footer-wid newsletter_widget">
                <div className="wid-title">
                  <h3>Our Location</h3>
                </div>
                <GoogleMap />
              </div>
            </div> */}


          </div>
        </div>
      </div>

      <FooterCta />
      <FooterOneCopyrights />
    </footer>
  );
};

export default FooterTwo;
